import { render } from "./TheStationsDetails.vue?vue&type=template&id=38da2fe6"
import script from "./TheStationsDetails.vue?vue&type=script&lang=js"
export * from "./TheStationsDetails.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__